<template>
    <span>
        <button class="btn btn-link text-dark" v-b-modal="'handover-modal' + _uid" @click="getLogs()">
            <i class="fa-solid fa-people-arrows fa-2xl"></i>
        </button>
        <b-modal :id="'handover-modal' + _uid" :hide-footer="true">
            <template slot="modal-header">
                <h4 class="modal-title">Átvételek</h4>
                <a class="btn-close" @click="$bvModal.hide('handover-modal' + _uid)"></a>
            </template>
            <loading v-if="!logs"></loading>
            <no-records v-else-if="logs.length == 0" main_icon="fa fa-solid fa-people-arrows" title="Nem található átvétel"></no-records>
            <div v-else class="tableFixHead">
                <table class="table">
                    <thead class="table-dark">
                        <tr>
                            <th>Esemény</th>
                            <th>Eredeti</th>
                            <th>Átvevő</th>
                            <th>Időpont</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(log,id) in logs" :key="id">
                            <td>{{ log.description }}</td>
                            <td>{{ log.prev_name }}</td>
                            <td>{{ log.user_name }}</td>
                            <td>{{ log.created_date }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-modal>
    </span>
</template>

<script>
    import Log from "../apis/Log"
    import Loading from '../components/Loading';
    import NoRecords from '../components/NoRecords';

    export default {
        props: {
            task_id: String
        },
        data(){
            return {
                logs:false
            }
        },
        components: {
            Loading, NoRecords
        },
        created(){
            this.getLogs();
        },
        methods: {
            getLogs(){
                Log.taskHandovers(this.task_id).then(response => {
                    this.logs = response.data;
                });
            }
        }
    }
</script>